import React, { useCallback } from 'react';

import cx from 'classnames';
import { ReactComponent as BidIcon } from 'assets/icons/bid.svg';
import { BiddingEventEmitter, events } from 'modules/bidding';

import { DISPATCHING } from 'modules/fleet/events';

const t = {
  bidding_enabled: 'This job accepts bids',
  has_bids: 'This job has',
  bids: 'bids',
  bid: 'bid',
};

const ItineraryBiddingCell = ({ itinerary, className }) => {
  const { is_bidding_enabled, number_of_bids, number_of_new_bids } = itinerary || {};

  const id = itinerary?.id;
  const journeyId = itinerary?.journey_id;
  const hasBids = number_of_bids > 0;
  const hasNewBids = number_of_new_bids > 0;

  const getDataTip = () => {
    if (hasBids) {
      return `${t.has_bids} ${number_of_bids} ${number_of_bids > 1 ? t.bids : t.bid}`;
    }
    return t.bidding_enabled;
  };

  const handleClick = useCallback(
    (e) => {
      DISPATCHING.OPEN_BIDDING({
        itinerary_id: id,
        journey_id: journeyId,
      });

      e.preventDefault();
      e.stopPropagation();
      BiddingEventEmitter.emit(events.OPEN_BIDDING, { journeyId });
    },
    [journeyId, id]
  );

  if (!is_bidding_enabled) {
    return null;
  }

  return (
    <div
      className={cx(className, { has_bids: hasBids })}
      data-for="generic-dispatching-tooltip"
      data-tip={getDataTip()}
      data-html={true}
      data-testid="bidding-cell"
      onClick={handleClick}
    >
      {hasNewBids && <span className="new_bids_icon" data-testid="new-bids-icon" />}
      <BidIcon />
    </div>
  );
};

export default ItineraryBiddingCell;
